import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import BModal from 'bootstrap-vue';
@Component({
  inheritAttrs: false,
})
export default class InputSelectOneComponent extends Vue {
  @Prop({ required: true })
  id: string;

  @Prop({ default: '' })
  label: string;

  @Prop({ default: '' })
  placeholder: string;

  @Prop({ default: true })
  readonly: boolean;

  @Prop({ default: true })
  valid: boolean;

  @Prop({ required: true })
  public value!: string;

  @Prop({ required: true, type: Array })
  public options!: Array<any>;

  get selectedId(): string {
    return this.value;
  }

  set selectedId(newValue: string) {
    this.$emit('input', newValue);
  }
}
